import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";

export const Properties = () => {

  return (
    <Grid2 style={{ paddingTop: 100 }} xs={9} container>
      Properties
    </Grid2>
  );
}

export default Properties;